
import React from 'react';
import { BookOpen, MessageSquare, FileText, Clock } from 'lucide-react';
import OnboardingLayout from '../../OnboardingLayout';

interface WelcomeScreenProps {
  onNext: () => void;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onNext }) => {
  return (
    <OnboardingLayout
      title="Welcome to DirectPress"
      subtitle="Where readers connect directly with journalists they trust"
      currentStep={1}
      totalSteps={9}
      onNext={onNext}
      onPrevious={() => {}}
      nextLabel="Get Started"
    >
      <div className="max-w-3xl mx-auto">
        <div className="bg-muted/30 rounded-lg p-6 mb-8">
          <h3 className="text-xl font-semibold mb-4">Why DirectPress?</h3>
          <p className="mb-4">
            DirectPress connects you directly with the journalists you trust, without algorithms
            or intermediaries. Pay only for what you value, and enjoy a personalized reading
            experience that respects your time and intelligence.
          </p>
          <p>
            Whether you follow individual journalists or specific topics, we'll help you discover
            high-quality content that matters to you.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-background rounded-lg p-5 border">
            <div className="flex items-center mb-3">
              <BookOpen className="h-6 w-6 text-primary mr-2" />
              <h4 className="text-lg font-medium">Quality Content</h4>
            </div>
            <p className="text-muted-foreground">
              Access high-quality journalism directly from expert writers across a range of topics.
            </p>
          </div>
          
          <div className="bg-background rounded-lg p-5 border">
            <div className="flex items-center mb-3">
              <MessageSquare className="h-6 w-6 text-primary mr-2" />
              <h4 className="text-lg font-medium">Direct Connection</h4>
            </div>
            <p className="text-muted-foreground">
              Interact directly with journalists, join discussions, and be part of a thoughtful community.
            </p>
          </div>
          
          <div className="bg-background rounded-lg p-5 border">
            <div className="flex items-center mb-3">
              <FileText className="h-6 w-6 text-primary mr-2" />
              <h4 className="text-lg font-medium">Personalized Experience</h4>
            </div>
            <p className="text-muted-foreground">
              See content tailored to your interests without the noise or distractions of social media.
            </p>
          </div>
          
          <div className="bg-background rounded-lg p-5 border">
            <div className="flex items-center mb-3">
              <Clock className="h-6 w-6 text-primary mr-2" />
              <h4 className="text-lg font-medium">Flexible Reading</h4>
            </div>
            <p className="text-muted-foreground">
              Read, listen, or use AI summaries to make the most of your time with our content.
            </p>
          </div>
        </div>
        
        <div className="text-center">
          <p className="text-muted-foreground">
            Let's set up your personalized reading experience in a few simple steps.
          </p>
        </div>
      </div>
    </OnboardingLayout>
  );
};

export default WelcomeScreen;
